// Module
var code = "<div class=\"codes-back-link\">\n  <back-link route-name=\"codes\">\n    All codes\n  </back-link>\n</div>\n";
// Exports
export default code;